export default accordion => {
    console.log('accordion');

    const button = accordion.querySelector('button');
    const accordionItemContainer = accordion.querySelector('.accordion-item-container');
    const accordionItemContent = accordion.querySelector('.accordion-item-content');

    function toggleAccordionItem() {
        if (!accordion.classList.contains('open')) {
            accordion.classList.add('open');
            accordionItemContainer.style.height = `${accordionItemContent.scrollHeight}px`;
        } else {
            accordion.classList.remove('open');
            accordionItemContainer.style.height = `${0}px`;
        }
    }

    button.addEventListener('click', toggleAccordionItem);
};
